module.exports = __webpack_public_path__ + "img/content_bg.927ff41c.png";